import { random } from 'lodash-es'

import usePopup from '../../HYBVant/HPopup/hooks/usePopup'

export default ({ value, onConfirm }: any) => {
  const { open, modalData, onCancel, onOpen } = usePopup({})
  const dataFormat = async (data: any) => {
    return {
      ...data,
      id: data?.id || random(100000)
    }
  }
  const add = () => {
    onOpen({ status: 'Add', editItem: {} })
  }

  const edit = (index: number) => {
    onOpen({ status: 'Edit', editItem: value?.[index] || {} })
  }

  const runSaveTraining = async (data: any) => {
    const healthItem = await dataFormat({ ...data })
    const isEdit = value?.findIndex((item: any) => item.id === healthItem.id) > -1
    const newHealthCertificates = value.map((item: any) => {
      if (item.id === healthItem?.id) {
        return healthItem
      }
      return item
    })
    onCancel()
    onConfirm(isEdit ? newHealthCertificates : [...value, healthItem])
  }

  const runDeleteTraining = (data: any) => {
    const rest = value.filter((item: any) => item.id !== data.id?.[0])
    onCancel()
    onConfirm(rest)
  }
  return {
    add,
    edit,
    open,
    modalData,
    onCancel,
    onOpen,
    runDeleteTraining,
    runSaveTraining,
    deleteTrainingLoading: false,
    saveTrainingLoading: false
  }
}
